export default {"src":"/_next/static/media/property_records_3.9fe35fa8.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};